import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import Colors from '../../../../../../constants/Colors';
import TemplateIcon30 from '../../../../../30pxIcons/TemplateIcon30';
import { TemplateType, TemplateTypeTitles } from '../../../../../../constants/Types';
import SensorIcon24 from '../../../../../24pxIcons/SensorIcon24';
import PressableStyled from '../../../../../PressableStyled';

interface TemplateListItemProps {
  selected: boolean,
  onPress: () => void,
  name: string,
  type?: TemplateType,
  testID?: string,
}

const TemplateListItem = ({
  name, selected, onPress, type = TemplateType.ASSET, testID,
}: TemplateListItemProps) => <PressableStyled
  style={[styles.container, selected && styles.containerSelected]}
  onPress={onPress}
  testID={testID}
>
    <View style={[styles.icon, selected && styles.iconSelected]}>
      {type === TemplateType.ASSET && <TemplateIcon30
        fill={selected ? Colors.light.hereworksBlue50 : Colors.light.hereworksDarkBlue}
        color={selected ? Colors.light.hereworksBlue500 : '#FFF'}
      />}
      {type === TemplateType.SENSOR
        && <SensorIcon24 color={selected ? Colors.light.hereworksBlue500 : '#FFF'} />}
      {type === TemplateType.METER
        && <SensorIcon24 color={selected ? Colors.light.hereworksBlue500 : '#FFF'} />}
    </View>
    <View>
      <Text style={[styles.title, selected && styles.titleSelected]}>{name}</Text>
      {false && type && <Text style={[styles.type, selected && styles.typeSelected]}>
        {TemplateTypeTitles[type]}
      </Text>}
    </View>
  </PressableStyled>;

const styles = StyleSheet.create({
  container: {
    flex: 1,
    paddingVertical: 8,
    paddingHorizontal: 16,
    borderRadius: 10,
    borderWidth: 1,
    backgroundColor: Colors.light.hereworksWhite100,
    borderColor: Colors.light.hereworksBlue100,
    marginBottom: 4,
    flexDirection: 'row',
    alignItems: 'center',
  },
  containerSelected: {
    backgroundColor: Colors.light.hereworksBlue500,
  },
  icon: {
    marginEnd: 12,
    width: 32,
    height: 32,
    borderRadius: 16,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: Colors.light.hereworksDarkBlue,
  },
  iconSelected: {
    backgroundColor: Colors.light.hereworksBlue50,
  },
  title: {
    fontSize: 14,
    lineHeight: 18,
    color: Colors.light.hereworksBlack600,
    fontFamily: 'Poppins_600SemiBold',
  },
  titleSelected: {
    color: '#FFF',
  },
  type: {
    fontSize: 12,
    lineHeight: 14,
    fontFamily: 'Roboto_400Regular',
    color: Colors.light.hereworksBlack400,
  },
  typeSelected: {
    color: Colors.light.hereworksBlue100,
  },
});

export default TemplateListItem;
